import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

import { fetchCompanies } from 'store/companies/actions';
import { companiesState as companiesStateSelector } from './selectors';
import { CompaniesState } from './types';

export const useCompaniesState = (): CompaniesState => useSelector(companiesStateSelector);

interface UseFetchCompanyOptionsParams {
  ownerId: string | undefined;
  after?: string;
  before?: string;
}

/**
 * Fetches the company filter options scoped to the active visits date range,
 * refetching whenever the range (or building) changes. Mirrors the
 * visitor-registration-admin model where filter options are scoped to the
 * displayed visits rather than listing every company in the building.
 */
export const useFetchCompanyOptions = ({ ownerId, after, before }: UseFetchCompanyOptionsParams): void => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (ownerId) {
      dispatch(fetchCompanies.request({ ownerId, after, before }));
    }
  }, [dispatch, ownerId, after, before]);
};
